import ErrorFallback from 'Components/ErrorFallback'
import { DynamicDrawerMenu } from 'Components/Layout/DrawerMenu/DynamicDrawerMenu'
import ParameterRoot from 'Services/ProductManagement/Features/Parameter'
import SalesRuleRoot from 'Services/ProductManagement/Features/SalesRule'
import { SettingsDrawerMenuContent } from 'Services/ProductManagement/Features/Settings/Components/SettingsDrawerMenuContent'
import { VATDefinitionRoot } from 'Services/ProductManagement/Features/VATDefinition'
import { ZoneDefinitionRoot } from 'Services/ProductManagement/Features/ZoneDefinition'
import { ErrorBoundary } from 'react-error-boundary'
import { Navigate, Route, Routes } from 'react-router-dom'

function SettingsRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <DynamicDrawerMenu drawerMenuContent={<SettingsDrawerMenuContent />} />
      <Routes>
        <Route index element={<Navigate to="product-parameters/" />} />
        <Route path="/product-parameters/*" element={<ParameterRoot />} />
        <Route path="/vat-definitions/*" element={<VATDefinitionRoot />} />
        <Route path="/zone-definitions/*" element={<ZoneDefinitionRoot />} />
        <Route path="/sales-rules/*" element={<SalesRuleRoot />} />
      </Routes>
    </ErrorBoundary>
  )
}
export default SettingsRoot
